export default __webpack_public_path__ + "static/media/2.edaa6567.jpeg";